import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=46d0b898&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=46d0b898&prod&lang=scss"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=46d0b898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d0b898",
  null
  
)

export default component.exports